var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5867_34805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3884 6.25059C21.3673 6.19434 20.7696 4.87246 19.4478 3.54355C17.6829 1.78574 15.454 0.850586 13.0001 0.850586C10.5462 0.850586 8.31729 1.78574 6.55244 3.54355C5.23057 4.87246 4.63291 6.19434 4.61182 6.25059C4.58043 6.32144 4.56421 6.39809 4.56421 6.47559C4.56421 6.55309 4.58043 6.62973 4.61182 6.70059C4.63291 6.75684 5.23057 8.07871 6.55244 9.40762C8.31729 11.1654 10.5462 12.1006 13.0001 12.1006C15.454 12.1006 17.6829 11.1654 19.4478 9.40762C20.7696 8.07871 21.3673 6.75684 21.3884 6.70059C21.4198 6.62973 21.436 6.55309 21.436 6.47559C21.436 6.39809 21.4198 6.32144 21.3884 6.25059ZM13.0001 3.94434C13.5007 3.94434 13.9901 4.09279 14.4064 4.37093C14.8226 4.64907 15.1471 5.04439 15.3387 5.50692C15.5303 5.96944 15.5804 6.47839 15.4827 6.96941C15.385 7.46042 15.144 7.91145 14.79 8.26545C14.436 8.61945 13.9849 8.86053 13.4939 8.9582C13.0029 9.05587 12.494 9.00574 12.0314 8.81416C11.5689 8.62257 11.1736 8.29814 10.8954 7.88187C10.6173 7.46561 10.4689 6.97622 10.4689 6.47559C10.4689 5.80426 10.7355 5.16042 11.2102 4.68572C11.6849 4.21102 12.3288 3.94434 13.0001 3.94434Z",
    fill: "#7B7B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5867_34805",
    x: 0.564209,
    y: 0.850586,
    width: 24.8718,
    height: 19.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5867_34805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5867_34805",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.0ca5c7ce6b7f903ba47a24592b478869.svg";
export { ForwardRef as ReactComponent };